module.exports = __webpack_public_path__ + "static/sawal-57133f03e155c845c9550da6bdf8c8f4.png";